// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BankFilledSvg from "@fishx/icons-svg/es/asn/BankFilled";
import FishxIcon from '../components/FishxIcon';

var BankFilled = function BankFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BankFilledSvg
  }));
};

BankFilled.displayName = 'BankFilled';
export default React.forwardRef(BankFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BankFilled.js
// module id = 2052
// module chunks = 0